import { render, staticRenderFns } from "./Orb2.vue?vue&type=template&id=84f14052&scoped=true&"
import script from "./Orb2.vue?vue&type=script&lang=js&"
export * from "./Orb2.vue?vue&type=script&lang=js&"
import style0 from "./Orb2.vue?vue&type=style&index=0&id=84f14052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f14052",
  null
  
)

export default component.exports